<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/mypurchase' }"
        >我的采购</el-breadcrumb-item
      >
      <el-breadcrumb-item>采购单号:{{ purchaseOrder.code }}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="main">
      <!-- 当前状态 -->
      <div style="display: flex; justify-content: space-between">
        <div class="main-flag">
          <b></b>
          <span
            >当前状态：<a>{{ changeStatus(purchaseOrder.status) }}</a></span
          >

          <div style="float: right; margin-left: 3rem">
            <flipDown
              :endDate="`${new Date(purchaseOrder.quoteEndTime).getTime()}`"
              :timeUnit="timeUnit"
            />
          </div>
        </div>
        <div></div>
        <p>
          <el-link
            v-if="purchaseOrder.contractUrl !== null"
            :underline="false"
            type="primary"
            :href="purchaseOrder.contractUrl"
            target="_blank"
            ><i class="el-icon-download"></i>
            下载合同
          </el-link>
          <span v-else style="margin-left: 30px; font-size: 12px"
            >暂无合同下载</span
          >
        </p>
      </div>
      <div class="nav_step">
        <el-steps :active="active" finish-status="success">
          <el-step
            v-for="(deliverItem, index) in deliver"
            :key="index"
            :title="deliverItem.name"
            :description="deliverItem.context"
            class="steps"
          ></el-step>
        </el-steps>
      </div>
      <!-- 采购商基本信息 -->
      <div class="info">
        <div class="main-flag">
          <b></b>
          <span>采购商基本信息</span>
        </div>
      </div>
      <el-row class="info_bk">
        <el-col :span="16" class="info_bk1">
          <el-row class="info_left">
            <el-col :span="12">
              <p>
                发布时间：<span>{{ purchaseOrder.createTime }}</span>
              </p>
            </el-col>
            <el-col :span="12">
              <p>
                招标类型：<span>{{ orderStatus(purchaseOrder.type) }}</span>
              </p>
            </el-col>
          </el-row>
          <el-row class="info_left">
            <el-col :span="12">
              <p>
                招标单号：<span>{{ purchaseOrder.code }}</span>
              </p>
            </el-col>
            <el-col :span="12">
              <p>
                送货地址：<span>{{ purchaseOrder.address }}</span>
              </p>
            </el-col>
          </el-row>
          <el-row class="info_left">
            <el-col :span="12">
              <p>
                报价截至：<span>{{ purchaseOrder.quoteEndTime }}</span>
              </p>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
        </el-col>
        <el-col :span="8" class="info_bk2">
          <el-button @click="handelechakn(1)">查看招标详情</el-button>
        </el-col>
      </el-row>
      <!-- 已收到？报价 -->
      <div class="offer">
        <template>
          <div class="main-flag">
            <b></b>
            <span
              >已收到<a>{{ purchaseOrder.quoteNum }}</a
              >家报价
            </span>
            <el-button
              :disabled="multiple"
              type="text"
              class="pricebtn1"
              @click="handleInvitation()"
            >
              邀约报价
            </el-button>
            <el-button
              type="text"
              class="pricebtn1"
              @click="showSummaryTables()"
            >
              查看汇总表
            </el-button>
            <el-button type="text" class="pricebtn1" @click="newOffer()">
              开启新一轮报价
            </el-button>
            <!-- <a href="" style="margin:0 20px;font-size: 18px;"></a> -->
          </div>
          <el-table
            :header-cell-style="headClass"
            :data="tableData"
            @selection-change="handleSelectionChange"
            style="width: 100%; margin-top: -5px; color: black"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="supplierName" label="报价供应商" width="500">
            </el-table-column>
            <el-table-column prop="amount" label="报价总金额" width="250">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="pricebtn"
                  @click="handleQuotedPrice(scope.row, scope.$index)"
                >
                  查看报价
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-for="(item, index) in controlsData" :key="index">
            <div class="main-flag">
              <b></b>
              <span class="histry">
                第 <a>{{ item.num }}</a> 轮<span
                  style="margin-left: 20px"
                ></span
                >已收到<a>{{ item.quoteInfos.length || 0 }}</a
                >家报价
              </span>
            </div>
            <!-- <el-row class="historytitle">
              <el-col :span="12">报价供应商</el-col>
              <el-col :span="12">报价总金额</el-col>
            </el-row>
            <el-row class="historymain" v-for="(items, indexs) in item.quoteInfos">
              <el-col :span="12">{{ items.supplierName }}</el-col>
              <el-col :span="12">{{ items.amount }}</el-col>
            </el-row> -->
            <!-- 多轮报价          -->
            <el-table
              :header-cell-style="headClass"
              :data="item.quoteInfos"
              style="width: 100%; margin-top: -5px; color: black"
            >
              <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
              <el-table-column prop="supplierName" label="报价供应商">
              </el-table-column>
              <el-table-column prop="amount" label="报价总金额">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    class="pricebtn"
                    @click="handleQuotedPrice(scope.row, scope.$index)"
                  >
                    查看报价
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-for="(item, index) in tableDataHistry" :key="index">
            <div class="main-flag">
              <b></b>
              <span class="histry"
                >已收到<a>{{ purchaseOrder.quoteNum }}</a
                >家报价--第 <a>{{ item.invite }}</a> 轮
              </span>
            </div>
            <el-row class="historytitle">
              <el-col :span="12">报价供应商</el-col>
              <el-col :span="12">报价总金额</el-col>
            </el-row>
            <el-row class="historymain">
              <el-col :span="12">{{ item.supplierName }}</el-col>
              <el-col :span="12">{{ item.amount }}</el-col>
            </el-row>
            <!-- <p>{{}}</p> -->
            <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
            <!-- <el-table-column prop="supplierName" label="报价供应商"> </el-table-column>
            <el-table-column prop="amount" label="报价总金额"> </el-table-column> -->
          </div>
        </template>
      </div>
    </div>
    <el-dialog
      title="汇总表"
      :visible.sync="isShowSummaryTables"
      :width="type2 != 1 ? '60%' : '90%'"
    >
      <el-table
        v-if="type2 != 1"
        ref="form"
        :data="summaryTables"
        style="width: 100%; margin-top: -5px; color: black"
      >
        <el-table-column prop="name" label="供应商"></el-table-column>
        <el-table-column prop="projectName" label="项目名称"></el-table-column>
        <el-table-column prop="workDescs" label="工作描述"></el-table-column>
        <el-table-column
          prop="calculateUnit"
          label="计量单位"
        ></el-table-column>
        <el-table-column prop="quantities" label="工程量"></el-table-column>
        <el-table-column
          prop="brandAndModel"
          label="品牌-型号"
        ></el-table-column>
        <el-table-column
          prop="stuffPrice"
          label="设备材料单价"
        ></el-table-column>
        <el-table-column prop="manMadePrice" label="人工单价"></el-table-column>
        <el-table-column
          prop="synthesizePrice"
          label="综合单价"
        ></el-table-column>
        <el-table-column prop="allPrice" label="合价"></el-table-column>
      </el-table>
      <el-table
        v-if="type2 == 1"
        ref="form"
        :data="summaryTables"
        style="width: 100%; margin-top: -5px; color: black"
      >
        <el-table-column prop="name" label="供应商"></el-table-column>
        <el-table-column prop="productName" label="产品名称"></el-table-column>
        <el-table-column prop="spec" label="规格型号"></el-table-column>
        <el-table-column
          prop="technicalRqmts"
          label="技术参数要求"
        ></el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column prop="priceLimit" label="报价上限"></el-table-column>
        <el-table-column prop="number" label="数量"></el-table-column>
        <el-table-column
          prop="subpackageName"
          label="分包名称"
        ></el-table-column>
        <el-table-column prop="workDesc" label="工作事项描述"></el-table-column>
        <el-table-column prop="deliverDays" label="发货时延"></el-table-column>
        <el-table-column prop="brand" label="品牌"></el-table-column>
        <el-table-column prop="service" label="服务名称"></el-table-column>
        <el-table-column
          prop="workDescribe"
          label="工作事项描述"
        ></el-table-column>
        <el-table-column
          prop="servicePeriod"
          label="服务期限"
        ></el-table-column>
        <el-table-column prop="accountPeriod" label="账期"></el-table-column>
        <el-table-column prop="amount" label="报价金额"></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowSummaryTables = false">取 消</el-button>
        <el-button type="primary" @click="downloadSummaryTables()"
          >下 载</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="新一轮报价" :visible.sync="isNewOffer" width="60%">
      <div>
        <el-form :model="newform" :rules="newRules" ref="newform">
          <el-form-item
            label="本轮报价开始时间"
            class="main-form-item"
            prop="startTime"
            label-width="140px"
          >
            <el-date-picker
              popper-class="popperClass"
              v-model="newform.startTime"
              type="datetime"
              style="width: 367px"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请输入日期"
              default-time="23:59:59"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="本轮报价结束时间"
            class="main-form-item"
            prop="endTime"
            label-width="140px"
          >
            <el-date-picker
              v-model="newform.endTime"
              type="datetime"
              style="width: 367px"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请输入日期"
              default-time="23:59:59"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click="isNewOffer = false">取 消</el-button>
          <!-- <el-button type="primary" @click="okNewOffer()">确定</el-button> -->
          <el-button
            type="success"
            @click="okNewOffer('form')"
            class="submit-button"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import flipDown from "vue-flip-down";
import { releaseDetails, invite, openNewQuote } from "@/api/xunyou";
export default {
  data() {
    return {
      type2: 1,
      summaryTables: [],
      isShowSummaryTables: false,
      timeUnit: ["天", "时", "分", "秒"],
      status: "",
      loading: true,
      quoteId: "",
      supplierId: "",
      type: JSON.parse(localStorage.getItem("userdata")).type, //1-供应商，3-采购商
      tableData: [],
      tableDataHistry: [], //历史报价
      controlsData: [], //多轮报价信息
      purchaseOrder: {},
      deliver: [],
      active: 0,

      //TODO 非多个禁用
      multiple: false,
      // 选中数组
      ids: [],
      purchaseOrderId: [],
      newform: {
        startTime: "",
        endTime: "",
      },
      isNewOffer: false,
      newRules: {
        startTime: [
          { required: true, message: "请填写日期", trigger: "change" },
        ],
        endTime: [{ required: true, message: "请填写日期", trigger: "change" }],
      },
    };
  },
  // 注册组件
  components: {
    flipDown,
  },
  created() {
    this.status = this.$route.query.status;
    this.handelData();
    // this.handelehistry();
  },
  methods: {
    downloadSummaryTables() {
      const a = document.createElement("a");
      a.href = `${this.$baseUrl}/custom/purchase/order/api/exportGather?purchaseOrderId=${this.$route.query.id}`;
      a.download = "汇总表.xlsx";
      a.click();
    },
    showSummaryTables() {
      this.$axios
        .get(
          `${this.$baseUrl}/custom/purchase/order/api/createGather?purchaseOrderId=${this.$route.query.id}`
        )
        .then((res) => {
          this.summaryTables = res.data.data;
          this.isShowSummaryTables = true;
          // console.log(res);
        });
    },
    // 新一轮报价
    newOffer() {
        this.isNewOffer = true;

    },
    okNewOffer() {
      let idsList =[]
      for (let index = 0; index < this.tableData.length; index++) {
        idsList.push(this.tableData[index].id);
      }
      this.$refs.newform.validate((valid) => {
        console.log(valid);
        if (valid) {
          if (this.newform.startTime && this.newform.endTime) {
            const startDate = this.newform.startTime;
            const endDate = this.newform.endTime;
            const startTime = new Date(startDate).getTime();
            const endTime = new Date(endDate).getTime();

            if (startTime > endTime) {
              this.$message.error("结束时间必须大于开始时间，请重新选择！");
              val.endTime = "";
            } else {
              let obj = {
                purchaseOrderId: this.$route.query.id,
                code: this.purchaseOrder.code,
                beginTime: this.newform.startTime,
                endTime: this.newform.endTime,
                ids:idsList.join(','),
              };
              openNewQuote(obj).then((res) => {
                console.log(res);
                if (res.code == 0) {
                  this.isNewOffer = false;
                  this.newform.startTime = "";
                  this.newform.endTime = "";
                  this.$message({
                    message: "成功",
                    type: "success",
                  });
                  location.reload();
                } else {
                  this.$message({
                    message: res.msg,
                    type: "error",
                  });
                }
              });
            }
          }
        }
      });
    },
    handleSelectionChange(val) {
      console.log(val, "val");
      this.ids = val.map((item) => item.id);
      this.purchaseOrderId = val.map((item) => item.purchaseOrderId);
      this.multiple = !val.length;
    },
    //   订单状态转换
    orderStatus(status) {
      switch (status) {
        case 1:
          return "现货/标准品";
          break;
        case 2:
          return "定制/加工品";
          break;
        case 3:
          return "定制服务";
          break;

        default:
          return "--";
      }
    },
    //   订单状态转换
    changeStatus(status) {
      switch (status) {
        case 0:
          return "审核中";
          break;
        case 1:
          return "审核不通过";
          break;
        case 2:
          return "报价中";
          break;
        case 3:
          return "待选定";
          break;
        case 4:
          return "已流标";
          break;
        case 5:
          return "已完成";
          break;
        case 6:
          return "已经弃标";
          break;
        case 7:
          return "已作废";
          break;

        default:
          return "--";
      }
    },
    //查询数据
    handelData() {
      this.loading = false;
      releaseDetails({ purchaseOrderId: this.$route.query.id }).then((res) => {
        this.purchaseOrder = res.data.purchaseOrder; //采购商基本信息
        this.tableData = res.data.quoteInfo; //报价信息
        this.controlsData = res.data.controls; //多轮报价信息
        this.tableDataHistry = res.data.quoteInfoHistory; //历史信息
        this.supplierId = res.data.purchaseOrder.id;
        this.deliver = res.data.stepDetails; //步骤
        this.active = res.data.active; //当前选中步骤
        this.type2 = res.data.purchaseOrder.type;
        // console.log(this.active, "active");
        if(this.active == 4||this.active == 5||this.active == 6){  // 报价结束
          this.purchaseOrder.quoteEndTime = ''
        }
      });
    },
    // handelehistry(){
    //     releaseDetails({ purchaseOrderId: this.$route.query.id,invite:3}).then((res) => {
    //   console.log(res,"res");
    //     // console.log(this.active, "active");
    //   });
    // },
    //查看采购详情
    handelechakn(type) {
      //type控制过去是2修改 1查看
      this.$router.push(
        `/RapidProcurement?purchaseOrderId=${this.$route.query.id}&type=${type}`
      );
    },
    // 表头样式设置
    headClass() {
      return "background:#eef1f6;color:black";
    },
    //邀约报价
    handleInvitation() {
      if (this.ids.length < 1) {
        this.$message({
          message: "请选择报价经销商",
          type: "warning",
        });
        return false;
      }

      let obj = {
        ids: this.ids.join(","),
      };
      invite(obj).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "发送成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查看报价
    handleQuotedPrice(item) {
      if (this.type == 3) {
        //采购商
        this.$router.push(
          `/quoteNow?quoteId=${item.id}&supplierId=${item.mid}&purchaseOrderId=${item.purchaseOrderId}&code=${item.code}&purchaseOrderCode=${item.purchaseOrderCode}&isSelected=${item.isSelected}`
        );
      }
    },
  },
};
</script>
<style lang="less" scoped>
.historytitle {
  // margin: 20px ;
  padding: 20px;
  font-weight: bold;
  background-color: #eef1f6;
  font-size: 15px;
  color: black;
}
.historymain {
  margin: 20px;
  color: black;
  font-size: 14px;
}
.nav_step {
  padding: 40px 0;
  width: 80%;
  margin: auto;
}
/deep/.el-step__head.is-process {
  color: #67c23a;
  border-color: #67c23a;
}
/deep/.el-step__title.is-process {
  font-weight: bold;
  color: #5fb878;
}
/deep/.vue-countdown-component .time-box,
/deep/.vue-countdown-component .time-box>div.back.anime,
// /deep/.vue-countdown-component .time-box>div.back,
/deep/.vue-countdown-component .time-box > div.face,
/deep/.vue-countdown-component .time-box > div.base .base-b {
  background-color: #d33a31 !important;
}
/deep/.el-step__head.is-success {
  color: #c65442;
  border-color: #c65442;
}
/deep/.el-step__title.is-success {
  color: #c65442;
}
/deep/.el-step__description.is-success {
  color: #c65442;
}
/deep/.cancel {
  float: none;
  margin-top: 0;
  color: #303133;
  border: 1px solid;
}

.main {
  background-color: white;
  padding: 20px;
  .main-flag {
    margin-bottom: 20px;
    margin-top: 20px;
    // margin-left: 20px;
    b {
      display: inline-block;
      width: 3px;
      height: 18px;
      background: #c6523f;
      vertical-align: middle;
    }
    span {
      font-weight: bold;
      font-size: 18px;
      padding-left: 8px;
      vertical-align: middle;
    }
    .histry {
      display: inline-block;
    }
    a {
      color: #c6523f;
    }
  }
  .info {
    margin: 20px 0;
  }
  .info_bk {
    border: 1px solid #eee;

    .info_bk1 {
      border-right: 1px solid #eee;
      .info_left {
        padding: 20px 10px 20px 15px;
        p {
          font-size: 14px;
          height: 5px;
          line-height: 5px;
          color: gray;
          span {
            color: black !important;
          }
        }
      }
    }
    .info_bk2 {
      height: 136px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
    }
  }

  .offer {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .pricebtn {
    width: 120px;
    border: 1px solid #c65442;
    background-color: rgb(241, 212, 212);
    color: #c65442;
  }
  .pricebtn1 {
    width: 120px;
    border: 1px solid #c65442;
    background-color: rgb(241, 212, 212);
    color: #c65442;
    margin: 0 20px;
  }
}
::v-deep .el-picker-panel .cancel {
  float: none;
  margin-top: 0;
  color: #303133;
  border: 1px solid;
}
</style>
<style lang="less" >
.popperClass {
  .cancel {
    float: none;
    margin-top: 0;
    color: #303133;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/procurementTenders/CorderDetails.vue